import * as React from "react";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { FrequencyTypeMap } from "../../../../../../Dashboard/Resoures/Contents";
import { FrequencyType } from "../../../../../../../Wrap/Constants/Enums/Domain/FrequencyType";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { AcornCommissionSettings } from "../../../../../../../Wrap/Models/Models/Company/AcornCommissionSettings";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { EdiMailBox } from "../../../../../../../Wrap/Models/Models/Company/EdiMailBox";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { addDays } from "../../../../../../../react-core/utils/date";
import { CompanyWizardAction } from "../../../Actions/CompanyWizardAction";

interface ICustomSettingProps extends IProcessComponentProps {
    data: FirmInstruction;
    onChange: (changes) => void;
    onRef: (ref) => void;
    isReview: boolean;
    ediOptions: EdiMailBox[];
    isNetWork: boolean;
}

interface ICustomSettingState {
    nextPaymentDate: Date;
}

export class CustomSetting extends ProcessComponent<ICustomSettingProps, ICustomSettingState> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextPaymentDate: new Date(),
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const { AcornCommissionSettings } = this.props.data;
        const frequency =
            AcornCommissionSettings?.Frequency == null ? FrequencyType.Weekly : AcornCommissionSettings?.Frequency;
        CompanyWizardAction.getNextPaymentDate(JsonDateParser.toJsonDateNoOffset(new Date()), frequency, (date) => {
            this.setState({ nextPaymentDate: date });
            this.onSettingsChange({ NextPayDate: date })
        });
    }

    private onSettingsChange(changes) {
        const { AcornCommissionSettings } = this.props.data;
        for (const key in changes) {
            AcornCommissionSettings[key] = changes[key];
        }
        this.props.onChange({ AcornCommissionSettings });
    }

    private getEmptySettings(): AcornCommissionSettings {
        return {
            Frequency: FrequencyType.Weekly,
            NextPayDate: JsonDateParser.toJsonDateNoOffset(addDays(new Date(), 7)),
            RequestStatement: true,
            RequestEDIFile: false,
            SuspendCommissionPayments: false,
        };
    }

    private onFrequencyChange(frequency: FrequencyType) {
        CompanyWizardAction.getNextPaymentDate(JsonDateParser.toJsonDateNoOffset(new Date()), frequency, (date) => {
            this.setState({ nextPaymentDate: date });

            this.onSettingsChange({ Frequency: frequency, NextPayDate: JsonDateParser.toDate(date) });
        });
    }

    render() {
        const { data, isReview, isNetWork } = this.props;
        if (!data.AcornCommissionSettings) {data.AcornCommissionSettings = this.getEmptySettings();}
        return (
            <>
                {SectionHeader(isNetWork ? "Network remuneration settings" : "Firm remuneration settings")}
                <SelectEditor
                    label="Remuneration option"
                    disabled={isReview}
                    options={[true, false]}
                    getText={(v) => {
                        return v
                            ? "Use default settings"
                            : isNetWork
                            ? "Use custom network settings"
                            : "Use custom firm settings";
                    }}
                    selected={data.UseDefaultCommissionOption}
                    onChange={(v) =>
                        this.props.onChange({ UseDefaultCommissionOption: v, AcornCommissionSettings: null })
                    }
                />
                {!data.UseDefaultCommissionOption && (
                    <>
                        <SelectEditor
                            disabled={isReview}
                            label="Frequency"
                            options={[
                                FrequencyType.Weekly,
                                FrequencyType.Fortnightly,
                                FrequencyType.Monthly,
                                FrequencyType.Quarterly,
                                FrequencyType.HalfYearly,
                                FrequencyType.Yearly,
                            ]}
                            required="Please select frequency"
                            getText={(v) => {
                                return FrequencyTypeMap[v];
                            }}
                            onChange={(v) => this.onFrequencyChange(v)}
                            selected={data.AcornCommissionSettings.Frequency}
                        />
                        <Typography
                            type="vertical"
                            config={[
                                {
                                    title: "Next payment date",
                                    data: JsonDateParser.getFormatDateString(
                                        JsonDateParser.toDate(this.state.nextPaymentDate),
                                        "dd-MM-yyyy",
                                        true,
                                        true
                                    ),
                                },
                            ]}
                        /> 
                        <CheckboxGroup
                            type="block"
                            options={[
                                {
                                    label: "Generate online statement",
                                    value: data.AcornCommissionSettings.RequestStatement,
                                    onChange: (v) => this.onSettingsChange({ RequestStatement: v }),
                                    disabled: isReview,
                                },
                                {
                                    label: "Generate EDI file",
                                    value: data.AcornCommissionSettings.RequestEDIFile,
                                    onChange: (v) => {
                                        if (!v) {
                                            this.props.onChange({ EdiId: "" });
                                        }
                                        this.onSettingsChange({ RequestEDIFile: v });
                                    },
                                    disabled: isReview,
                                },
                                {
                                    label: "Suspend charges payment",
                                    value: data.AcornCommissionSettings.SuspendCommissionPayments,
                                    onChange: (v) => this.onSettingsChange({ SuspendCommissionPayments: v }),
                                    disabled: isReview,
                                },
                            ]}
                        />
                        {data.AcornCommissionSettings.RequestEDIFile && (
                            <SelectEditor
                                disabled={isReview}
                                label="EDI mailbox destination"
                                options={this.props.ediOptions.map((v) => v.EdiId)}
                                getText={(v) => this.props.ediOptions.find((o) => o.EdiId == v)?.CompanyName}
                                required="Please select EDI mailbox destination"
                                placeholder="Please select"
                                onChange={(v) => this.props.onChange({ EdiId: v })}
                                selected={data.EdiId}
                            />
                        )}
                    </>
                )}
            </>
        );
    }
}
